var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-secondary-3 p-3 mt-3 rounded" }, [
    _c("div", { staticClass: "row px-3" }, [
      _c("div", { staticClass: "col-12 col-md-4" }, [
        _c("span", { staticClass: "font-weight-normal text-gray font-14" }, [
          _vm._v(" Tipo de Documento: ")
        ]),
        _c("p", { staticClass: "font-16" }, [
          _vm._v(_vm._s(_vm.document.documentType.name))
        ])
      ]),
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _vm.fileName
          ? _c(
              "span",
              { staticClass: "font-weight-normal text-gray font-14" },
              [_vm._v(" Archivo: ")]
            )
          : _vm._e(),
        _c("p", { staticClass: "font-16" }, [_vm._v(_vm._s(_vm.fileName))])
      ]),
      _c(
        "div",
        { staticClass: "col-12 col-md-2 text-right" },
        [
          (!_vm.readOnly && !_vm.addingAddendum) || this.document.file
            ? _c("action-button", {
                staticClass: "mr-2 mt-2",
                attrs: { i: "fas fa-times-circle", variant: "danger" },
                on: { click: () => _vm.$emit("on-remove", _vm.index) }
              })
            : _vm._e(),
          _c("action-button", {
            staticClass: "mr-2 mt-2",
            attrs: { i: "fas fa-file-download", variant: "success" },
            on: { click: () => _vm.$emit("on-download", _vm.document) }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }